/**
 * @file   src\mobile\components\MarkAsSoldStep2Modal.js
 * @brief  This file is responsible for second step of mark as sold action on inventory
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import { Modal } from "react-bootstrap";

const MarkAsSoldStep2Modal = (props) => {
  const { show, onHide } = props;

  return (
    <Modal
      show={show}
      {...props}
      onHide={onHide}
      centered
      className="modalPopupstyle delete-popup sold-popup"
    >
      <Modal.Body className="text-center">
        <h3>Did Gitcha help with this transaction?</h3>
        <div className="questions-block">
          <div className="options">
            <a href={void 0} className="blockBtn text-center">
              Yes
            </a>
            <a href={void 0} className="blockBtn text-center">
              {" "}
              No{" "}
            </a>
          </div>
        </div>
        <div className="btn-wrap">
          <div className="btn-block">
            <button
              type="button"
              className="btn btn-primary btn-skip w-100"
              onClick={onHide}
            >
              Skip <i className="ic-arrow"></i>
            </button>
          </div>
          <button
            type="button"
            className="btn btn-secondary w-100"
            onClick={onHide}
          >
            Back
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default MarkAsSoldStep2Modal;
